import { HistoryFiltersConfig } from '../../configuration'

/**
 * Array of attribute names to display in the Attributes filter for Basketball.
 * These names will be matched dynamically against incident attributes from the sport API data.
 */
export const historyFiltersAttributesConfig: HistoryFiltersConfig['historyFiltersAttributes'] =
  [
    'Jump shot',
    'Layup',
    'Dunk',
    'Hook',
    'And 1',
    'Step back',
    'Alley oop',
    'Driving',
    'Floating',
    'Tip-putback',
    'Deep 3',
    'Half court',
    'Points from turnovers',
    'Points in the paint',
    'Second chance points',
    'Fast break points',
    'One',
    'Two',
    'Three',
    'Out of bounds',
    'Travelling',
    'Shot clock',
    'Backcourt',
    '8 seconds',
    '5 seconds',
    '3 seconds',
    'Double dribble',
    'Offensive goaltending',
    'Offensive',
    'Technical',
    'Unsportsmanlike',
  ]
